import { FormType } from '../../../form-types';

export const ldn: FormType = {
  name: 'Low Dose Naltrexone (LDN) Questionnaire',
  questions: [
    {
      key: 'ldn_sexAssignedAtBirth',
      next: {
        condition: { 'ldn_sexAssignedAtBirth.male': true },
        key: 'ldn_height',
        els: 'ldn_pregnancy'
      }
    },
    {
      key: 'ldn_pregnancy',
      next: {
        condition: { 'ldn_pregnancy.yes': true },
        key: 'ldn_ineligible',
        els: 'ldn_pregnancyConsent'
      }
    },
    {
      key: 'ldn_pregnancyConsent',
      next: {
        condition: { 'ldn_pregnancyConsent.non_consent': true },
        key: 'ldn_ineligible',
        els: 'ldn_height'
      }
    },
    'ldn_height',
    'ldn_weight',
    {
      key: 'ldn_chronicPainAcknowledgment',
      next: {
        condition: { 'ldn_chronicPainAcknowledgment.acute_or_unknown': true },
        key: 'ldn_ineligible',
        els: 'ldn_primaryInflammatorySymptoms'
      }
    },
    {
      key: 'ldn_primaryInflammatorySymptoms',
      next: {
        condition: { 'ldn_primaryInflammatorySymptoms.other': true },
        key: 'ldn_primaryInflammatorySymptomsOther',
        els: 'ldn_symptomsOnset'
      }
    },
    'ldn_primaryInflammatorySymptomsOther',
    {
      key: 'ldn_symptomsOnset',
      next: {
        condition: { 'ldn_symptomsOnset.less_12_weeks': true },
        key: 'ldn_ineligible',
        els: 'ldn_inflammatoryConditions'
      }
    },
    {
      key: 'ldn_inflammatoryConditions',
      next: {
        condition: { 'ldn_inflammatoryConditions.other': true },
        key: 'ldn_inflammatoryConditionsOther',
        els: 'ldn_inflammationTriggers'
      }
    },
    'ldn_inflammatoryConditionsOther',
    {
      key: 'ldn_inflammationTriggers',
      next: {
        condition: { 'ldn_inflammationTriggers.other': true },
        key: 'ldn_inflammationTriggersOther',
        els: 'ldn_treatmentsTried'
      }
    },
    'ldn_inflammationTriggersOther',
    'ldn_treatmentsTried',
    {
      key: 'ldn_takenNaltrexoneBefore',
      next: {
        condition: { 'ldn_takenNaltrexoneBefore.yes': true },
        key: 'ldn_respondedWellToNaltrexone',
        els: 'ldn_currentOpioids'
      }
    },
    'ldn_respondedWellToNaltrexone',
    {
      key: 'ldn_sideEffectsToNaltrexone',
      next: {
        condition: { 'ldn_sideEffectsToNaltrexone.yes': true },
        key: 'ldn_sideEffectsToNaltrexoneDetails',
        els: 'ldn_currentOpioids'
      }
    },
    'ldn_sideEffectsToNaltrexoneDetails',
    {
      key: 'ldn_currentOpioids',
      next: {
        condition: { 'ldn_currentOpioids.yes': true },
        key: 'ldn_ineligible',
        els: 'ldn_opioidUseDisorder'
      }
    },
    {
      key: 'ldn_opioidUseDisorder',
      next: {
        condition: { 'ldn_opioidUseDisorder.yes': true },
        key: 'ldn_ineligible',
        els: 'ldn_liverKidneyDisease'
      }
    },
    {
      key: 'ldn_liverKidneyDisease',
      next: {
        condition: { 'ldn_liverKidneyDisease.yes': true },
        key: 'ldn_ineligible',
        els: 'ldn_mentalHealthHistory'
      }
    },
    {
      key: 'ldn_mentalHealthHistory',
      next: {
        condition: { 'ldn_mentalHealthHistory.yes': true },
        key: 'ldn_ineligible',
        els: 'ldn_additionalInfo'
      }
    },
    'ldn_additionalInfo',
    {
      key: 'ldn_truthfulnessConsent',
      next: {
        condition: { 'ldn_truthfulnessConsent.non_consent': true },
        key: 'ldn_ineligible',
        els: 'ldn_therapyConsent'
      }
    },
    {
      key: 'ldn_therapyConsent',
      next: {
        condition: { 'ldn_therapyConsent.non_consent': true },
        key: 'ldn_ineligible',
        els: 'ldn_complete'
      }
    },
    'ldn_complete',
    'ldn_ineligible'
  ]
};
